module.exports = __webpack_public_path__ + "static/media/55_000025.cdd5ef02.jpg";